// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusiness2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M22.156 9.233v10.831H1.845V9.466"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M19.632 16.166h-2.76v-3.902h2.76zM7.128 16.166h-2.76v-3.902h2.76zM14.11 20.064H9.888v-7.8h4.22zM1.475 3.936h5.262L6.43 7.234a2.787 2.787 0 0 1-5.572 0z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M6.737 3.936H12v3.298a2.787 2.787 0 0 1-5.571 0z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M12 3.936h5.263l.308 3.298a2.787 2.787 0 0 1-5.571 0z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M17.263 3.936h5.263l.617 3.298a2.787 2.787 0 0 1-5.572 0z"
    />
  </svg>
);
export default SvgBusiness2;
